export const oilsDatabase = [
    { value: "abōde", label: "abōde" },
    { value: "Adaptiv", label: "Adaptiv" },
    { value: "Aglaia Touch", label: "Aglaia Touch" },
    { value: "Air", label: "Air" },
    { value: "Air-X", label: "Air-X" },
    { value: "Align", label: "Align" },
    { value: "Amavi", label: "Amavi" },
    { value: "Amazon Escape", label: "Amazon Escape" },
    { value: "Anchor", label: "Anchor" },
    { value: "Anise Myrtle", label: "Anise Myrtle" },
    { value: "Angelica", label: "Angelica" },
    { value: "Arborvitae", label: "Arborvitae" },
    { value: "Arise", label: "Arise" },
    { value: "AromaTouch", label: "AromaTouch" },
    { value: "Autumn Breeze", label: "Autumn Breeze" },
    { value: "Baking Spice", label: "Baking Spice" },
    { value: "Balance", label: "Balance" },
    { value: "Balsam Fir", label: "Balsam Fir" },
    { value: "Basil", label: "Basil" },
    { value: "Beautiful Touch", label: "Beautiful Touch" },
    { value: "Beloved", label: "Beloved" },
    { value: "Bergamot", label: "Bergamot" },
    { value: "Bergamot Mint", label: "Bergamot Mint" },
    { value: "Birch", label: "Birch" },
    { value: "Black Pepper", label: "Black Pepper" },
    { value: "Black Spruce", label: "Black Spruce" },
    { value: "Blue Lotus Touch", label: "Blue Lotus Touch" },
    { value: "Blue Tansy", label: "Blue Tansy" },
    { value: "Brave", label: "Brave" },
    { value: "Breathe", label: "Breathe" },
    { value: "Breu Branco", label: "Breu Branco" },
    { value: "Buddha Wood", label: "Buddha Wood" },
    { value: "Buntan", label: "Buntan" },
    { value: "Cadewood", label: "Cadewood" },
    { value: "Calmer", label: "Calmer" },
    { value: "Cananga", label: "Cananga" },
    { value: "Caraway", label: "Caraway" },
    { value: "Cardamom", label: "Cardamom" },
    { value: "Cassia", label: "Cassia" },
    { value: "Cedarwood", label: "Cedarwood" },
    { value: "Celery Seed", label: "Celery Seed" },
    { value: "Cheer", label: "Cheer" },
    { value: "Chrysanthemum Touch", label: "Chrysanthemum Touch" },
    { value: "Cilantro", label: "Cilantro" },
    { value: "Cinnamon Bark", label: "Cinnamon Bark" },
    { value: "Cistus", label: "Cistus" },
    { value: "Citronella", label: "Citronella" },
    { value: "Citrus Bliss", label: "Citrus Bliss" },
    { value: "Citrus Bloom", label: "Citrus Bloom" },
    { value: "Citrus Spring", label: "Citrus Spring" },
    { value: "Citrus Twist", label: "Citrus Twist" },
    { value: "Clary Sage", label: "Clary Sage" },
    { value: "ClaryCalm", label: "ClaryCalm" },
    { value: "Clementine", label: "Clementine" },
    { value: "Clove", label: "Clove" },
    { value: "Coast", label: "Coast" },
    { value: "Coastel Escape", label: "Coastel Escape" },
    { value: "Common Myrtle", label: "Common Myrtle" },
    { value: "Console", label: "Console" },
    { value: "Copaiba", label: "Copaiba" },
    { value: "Coriander", label: "Coriander" },
    { value: "Costa Brio", label: "Costa Brio" },
    { value: "Cumin", label: "Cumin" },
    { value: "Cypress", label: "Cypress" },
    { value: "Damiana Touch", label: "Damiana Touch" },
    { value: "Davana Touch", label: "Davana Touch" },
    { value: "DDR PRIME", label: "DDR PRIME" },
    { value: "Deep Blue", label: "Deep Blue" },
    { value: "Desert Island", label: "Desert Island" },
    { value: "DigestZen", label: "DigestZen" },
    { value: "Dill", label: "Dill" },
    { value: "Douglas Fir", label: "Douglas Fir" },
    { value: "Elevation", label: "Elevation" },
    { value: "Endless Summer", label: "Endless Summer" },
    { value: "Erva Baleeira", label: "Erva Baleeira" },
    { value: "Eucalyptus", label: "Eucalyptus" },
    { value: "Fennel", label: "Fennel" },
    { value: "Forgive", label: "Forgive" },
    { value: "Fragonia", label: "Fragonia" },
    { value: "Frankincense", label: "Frankincense" },
    { value: "Galbanum", label: "Galbanum" },
    { value: "Gardenia Touch", label: "Gardenia Touch" },
    { value: "Geranium", label: "Geranium" },
    { value: "Ginger", label: "Ginger" },
    { value: "Ginseng", label: "Ginseng" },
    { value: "Grapefruit", label: "Grapefruit" },
    { value: "Green Mandarin", label: "Green Mandarin" },
    { value: "Guaiacwood", label: "Guaiacwood" },
    { value: "Harvest Spice", label: "Harvest Spice" },
    { value: "Helichrysum", label: "Helichrysum" },
    { value: "Himalayan Fir", label: "Himalayan Fir" },
    { value: "Hinoki", label: "Hinoki" },
    { value: "Holiday Joy", label: "Holiday Joy" },
    { value: "Holiday Love", label: "Holiday Love" },
    { value: "Holiday Peace", label: "Holiday Peace" },
    { value: "Honey Myrtle", label: "Honey Myrtle" },
    { value: "Honeysuckle Touch", label: "Honeysuckle Touch" },
    { value: "Hope Touch", label: "Hope Touch" },
    { value: "Hygge", label: "Hygge" },
    { value: "Hyssop", label: "Hyssop" },
    { value: "InTune Touch", label: "InTune Touch" },
    { value: "Island Mint", label: "Island Mint" },
    { value: "Italian", label: "Italian" },
    { value: "Japanese Peppermint", label: "Japanese Peppermint" },
    { value: "Jasmine", label: "Jasmine" },
    { value: "Juniper Berry", label: "Juniper Berry" },
    { value: "Kānuka", label: "Kānuka" },
    { value: "Kumquat", label: "Kumquat" },
    { value: "Laurel Leaf", label: "Laurel Leaf" },
    { value: "Lavender", label: "Lavender" },
    { value: "Lemon", label: "Lemon" },
    { value: "Lemon Eucalyptus", label: "Lemon Eucalyptus" },
    { value: "Lemon Myrtle", label: "Lemon Myrtle" },
    { value: "Lemongrass", label: "Lemongrass" },
    { value: "Lime", label: "Lime" },
    { value: "Litsea", label: "Litsea" },
    { value: "Lotus Twilight", label: "Lotus Twilight" },
    { value: "Madagascar Vanilla", label: "Madagascar Vanilla" },
    { value: "Magnolia Touch", label: "Magnolia Touch" },
    { value: "Mālama", label: "Mālama" },
    { value: "Mānuka", label: "Mānuka" },
    { value: "Marjoram", label: "Marjoram" },
    { value: "Melissa", label: "Melissa" },
    { value: "MetaPWR", label: "MetaPWR" },
    { value: "Mexican", label: "Mexican" },
    { value: "Midnight Forest", label: "Midnight Forest" },
    { value: "Morino-To", label: "Morino-To" },
    { value: "Motivate", label: "Motivate" },
    { value: "Myrrh", label: "Myrrh" },
    { value: "Naio Wood", label: "Naio Wood" },
    { value: "Native Bush", label: "Native Bush" },
    { value: "Neroli Touch", label: "Neroli Touch" },
    { value: "Neshama Touch", label: "Neshama Touch" },
    { value: "Niaouli", label: "Niaouli" },
    { value: "Nootka", label: "Nootka" },
    { value: "Northern Escape", label: "Northern Escape" },
    { value: "ōasis", label: "ōasis" },
    { value: "On Guard", label: "On Guard" },
    { value: "Oregano", label: "Oregano" },
    { value: "Osmanthus Touch", label: "Osmanthus Touch" },
    { value: "Palmarosa", label: "Palmarosa" },
    { value: "Passion", label: "Passion" },
    { value: "Past Tense", label: "Past Tense" },
    { value: "Patchouli", label: "Patchouli" },
    { value: "Peace", label: "Peace" },
    { value: "Peppermint", label: "Peppermint" },
    { value: "Petitgrain", label: "Petitgrain" },
    { value: "Phenomenal", label: "Phenomenal" },
    { value: "Pink Pepper", label: "Pink Pepper" },
    { value: "Purify", label: "Purify" },
    { value: "Ravintsara", label: "Ravintsara" },
    { value: "Red Mandarin", label: "Red Mandarin" },
    { value: "Rescuer", label: "Rescuer" },
    { value: "Roman Chamomile", label: "Roman Chamomile" },
    { value: "Rosalina", label: "Rosalina" },
    { value: "Rose", label: "Rose" },
    { value: "Rosemary", label: "Rosemary" },
    { value: "Salubelle", label: "Salubelle" },
    { value: "Sandalwood", label: "Sandalwood" },
    { value: "Sandalwood Hawaiian", label: "Sandalwood Hawaiian" },
    { value: "Schisandra", label: "Schisandra" },
    { value: "Serenity", label: "Serenity" },
    { value: "Shinrin-Yoku", label: "Shinrin-Yoku" },
    { value: "Siberian Fir", label: "Siberian Fir" },
    { value: "Sievers Wormwood", label: "Sievers Wormwood" },
    { value: "Slim & Sassy", label: "Slim & Sassy" },
    { value: "Smart & Sassy", label: "Smart & Sassy" },
    { value: "Spanish Sage", label: "Spanish Sage" },
    { value: "Spearmint", label: "Spearmint" },
    { value: "Spikenard", label: "Spikenard" },
    { value: "Star Anise", label: "Star Anise" },
    { value: "Steady", label: "Steady" },
    { value: "Stronger", label: "Stronger" },
    { value: "Summer Savory", label: "Summer Savory" },
    { value: "Sunny Citrus", label: "Sunny Citrus" },
    { value: "SuperMint", label: "SuperMint" },
    { value: "Sweetgum", label: "Sweetgum" },
    { value: "Tamer", label: "Tamer" },
    { value: "Tangerine", label: "Tangerine" },
    { value: "Tea Tree", label: "Tea Tree" },
    { value: "TerraBlend LLV", label: "TerraBlend LLV" },
    { value: "TerraShield", label: "TerraShield" },
    { value: "Thai", label: "Thai" },
    { value: "Thinker", label: "Thinker" },
    { value: "Thyme", label: "Thyme" },
    { value: "Tropical", label: "Tropical" },
    { value: "Tulsi (Holy Basil)", label: "Tulsi (Holy Basil)" },
    { value: "Turmeric", label: "Turmeric" },
    { value: "Unspoken", label: "Unspoken" },
    { value: "Valerian", label: "Valerian" },
    { value: "Vanilla Chai", label: "Vanilla Chai" },
    { value: "Vetiver", label: "Vetiver" },
    { value: "Vineyard Escape", label: "Vineyard Escape" },
    { value: "Warm Embrace Touch", label: "Warm Embrace Touch" },
    { value: "Western Bloom 5ml", label: "Western Bloom 5ml" },
    { value: "Whisper", label: "Whisper" },
    { value: "White Fir", label: "White Fir" },
    { value: "White Grapefruit", label: "White Grapefruit" },
    { value: "Wild Orange", label: "Wild Orange" },
    { value: "Wintergreen", label: "Wintergreen" },
    { value: "Yarrow|Pom", label: "Yarrow|Pom" },
    { value: "Yellow Mandarin", label: "Yellow Mandarin" },
    { value: "Ylang Ylang", label: "Ylang Ylang" },
    { value: "Yule Log", label: "Yule Log" },
    { value: "Yuzu", label: "Yuzu" },
    { value: "Zendocrine", label: "Zendocrine" },
    { value: "ZenGest", label: "ZenGest" },
    { value: "dōTERRA | Clean", label: "dōTERRA | Clean" },
    { value: "dōTERRA | Baby", label: "dōTERRA | Baby" },
    { value: "dōTERRA | Gala Touch", label: "dōTERRA | Gala Touch" },
    { value: "dōTERRA | Hair care", label: "dōTERRA | Hair care" },
    { value: "dōTERRA | HD Clear", label: "dōTERRA | HD Clear" },
    { value: "dōTERRA | Nutrition", label: "dōTERRA | Nutrition" },
    { value: "dōTERRA | Oils", label: "dōTERRA | Oils" },
    { value: "dōTERRA | Parfum", label: "dōTERRA | Parfum" },
    { value: "dōTERRA | Skin Care", label: "dōTERRA | Skin Care" },
    { value: "dōTERRA | Spa", label: "dōTERRA | Spa" },
    { value: "dōTERRA | Sun", label: "dōTERRA | Sun" },
    { value: "dōTERRA | Suppliments", label: "dōTERRA | Suppliments" },
    { value: "dōTERRA | Verage", label: "dōTERRA | Verage" },
    { value: "dōTERRA | Women", label: "dōTERRA | Women" },
  ];